const baseDashboardPath = '/d';
const routePaths = {
  clinics: `${baseDashboardPath}/clinics`,
  welcome: `${baseDashboardPath}/welcome`,
  roles: `${baseDashboardPath}/roles`,
  permissions: `${baseDashboardPath}/permissions`,
  users: `${baseDashboardPath}/users`,
  knowledgeBase: `${baseDashboardPath}/knowledge-base`,
  vaccines: `${baseDashboardPath}/knowledge-base/vaccines`,
  soap: `${baseDashboardPath}/knowledge-base/soap`,
  differentials: `${baseDashboardPath}/knowledge-base/differentials`,
  medicationsInventory: `${baseDashboardPath}/knowledge-base/medications-inventory`,
  petProfiles: `${baseDashboardPath}/pet-profiles`,
  hospitalSetting: `${baseDashboardPath}/hospital-setting`,
  petParents: `${baseDashboardPath}/pets`,
  integrations: `${baseDashboardPath}/integrations`,
  configurations: `${baseDashboardPath}/configurations`,
  requests: `${baseDashboardPath}/requests`,
};

export default routePaths;
